export const floatToString = (value: number, fractionDigits = 2) => {
  return `${stringToFloat(value.toFixed(fractionDigits))}`;
};

export const stringToFloat = (value: string | null | undefined) => {
  return parseFloat(value || "") || 0;
};